export default __webpack_public_path__ + "static/media/facebook.607a88a7.svg";